
import React from 'react';

import { usePhoneScreen, useStore } from '../../hooks';
import CloseButton from './CloseButton';
import ResetButton from './ResetButton';
import UndoButton from './UndoButton';
import RedoButton from './RedoButton';
import ImageDimensionsAndDisplayToggle from './ImageDimensionsAndDisplayToggle';
import CanvasZooming from './CanvasZooming';
import { StyledTopbar } from './Topbar.styled';
import BackButton from './BackButton';
import SaveButtonCustom from './SaveButtonCustom';
import BannerFrameSizeToggle from './BannerFrameSizeToggle';
import LayersPanelToggle from './LayersPanelToggle';
import EditorTopbarHelp from '../../../../EditorTopbarHelp';
import EditorThemeToggle from './EditorThemeToggle';
const Topbar = () => {
  const {
    config: { showBackButton, disableZooming },
  } = useStore();
  const isPhoneScreen = usePhoneScreen();

  return (
    <StyledTopbar reverseDirection={showBackButton} className="respark_topbar">
      <div className="respark_topbar-toolbar">
        <BannerFrameSizeToggle />

        {!disableZooming && (
          <div className="respark_topbar-group respark_topbar-group--zoom">
            <CanvasZooming />
          </div>
        )}

        <div className="respark_topbar-group respark_topbar-group--history">
          <ResetButton margin="0" />
          <UndoButton margin="0" />
          <RedoButton margin="0" />
        </div>

        <EditorThemeToggle />
        <LayersPanelToggle />
        <ImageDimensionsAndDisplayToggle />
        {isPhoneScreen ? <EditorTopbarHelp /> : null}
        <SaveButtonCustom />
        {showBackButton ? <BackButton /> : <CloseButton />}
      </div>
    </StyledTopbar>
  );
};
export default Topbar;
